import { MapUtils } from '../../../utility/map-utils.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
} from '../../dto/data-model.js';

export class PartnerApp extends DataModel {
  static readonly TYPE_ID: string = 'efe95367d0714381ba349d77b5f7b6d3';

  private constructor(
    public readonly uniqueId: string,
    public readonly name: string,
  ) {
    super();
  }

  get $typeId(): string {
    return PartnerApp.TYPE_ID;
  }

  static create(args: {
    uniqueId: string,
    name: string,
  }): PartnerApp {
    return new PartnerApp(
        args.uniqueId,
        args.name,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): PartnerApp {
    return PartnerApp.create({
      uniqueId: MapUtils.getString(map, 'uniqueId'),
      name: MapUtils.getString(map, 'name'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      uniqueId: this.uniqueId,
      name: this.name,
    };
  }

  clone(): this {
    return PartnerApp.create({
      uniqueId: this.uniqueId,
      name: this.name,
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
      other.name === this.name;
  }
}

export class PartnerAppBuilder extends DataModelBuilder<PartnerApp> {
  build(context: SerializationContext, map: SerializedData): PartnerApp {
    return PartnerApp.fromMap(context, map);
  }
}
